import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CardFilterEntity } from '../../domain/entities/CardFilterEntity'

export class CardFilterModel extends CardFilterEntity {
  regionId?: number
  channelId?: number
  constructor(dataDto: CardFilterEntity) {
    super()
    mapEntityProperties<CardFilterModel>(this, dataDto, {
      exclude: ['region', 'channel'],
      map: {
        regionId: dataDto.region?.id,
        channelId: dataDto.channel?.id
      }
    })
  }
}
